import { Achievement } from './achievement.shared.model';
import { GoalBreakpointOption } from './quizBreakpointOptions.shared.model';
export var QuizId = /*#__PURE__*/function (QuizId) {
  QuizId[QuizId["MEASURE"] = 1] = "MEASURE";
  QuizId[QuizId["LH"] = 2] = "LH";
  QuizId[QuizId["PERIOD"] = 3] = "PERIOD";
  QuizId[QuizId["CYCLE"] = 4] = "CYCLE";
  QuizId[QuizId["FOLLICULAR"] = 5] = "FOLLICULAR";
  QuizId[QuizId["VULVA"] = 6] = "VULVA";
  return QuizId;
}(QuizId || {});
export const ACHIEVEMENT_BY_QUIZ = {
  [QuizId.MEASURE]: Achievement.quizMeasuring,
  [QuizId.LH]: Achievement.quizLh,
  [QuizId.PERIOD]: Achievement.quizPeriod,
  [QuizId.CYCLE]: Achievement.quizCycle,
  [QuizId.FOLLICULAR]: Achievement.quizFollicular,
  [QuizId.VULVA]: Achievement.quizVulva
};
/**
 * Goal options that will skip most of the quiz
 * These options go straight from the goal page to the page after the quiz
 */
export const shortQuizGoalOptions = [GoalBreakpointOption.postPartum, GoalBreakpointOption.trackPregnancy];